<template>
    <div class="main-container">

        <router-view></router-view>
        
        <!-- Navbar section -->
        <HeaderElement />

        <!-- breadcrumb strat -->
        <Breadcrumb>
            <template slot="breadcrumb">
                <div class="breadcrumb_box text-center">
                    <h2 class="breadcrumb-title">Tabs</h2>
                    <!-- breadcrumb-list start -->
                    <ul class="breadcrumb-list">
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">Home</router-link></li>
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">Elements</router-link></li>
                        <li class="breadcrumb-item active">Tabs</li>
                    </ul>
                    <!-- breadcrumb-list end -->
                </div>
            </template>
        </Breadcrumb>
        <!-- breadcrumb end -->

        <!-- tab one components start -->
        <div class="tabs-wrapper section-space--ptb_90">
            <div class="container">
                <TabOne />
            </div>
        </div>
        <!-- tab one components start -->

        <!-- tab two components start -->
        <TabTwo BgGradient="bg-gradient" />
        <!-- tab two components start -->

        <!-- footer section -->
        <FooterMain/>

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />

    </div>
</template>

<script>
    import HeaderElement from '@/components/HeaderElement'
    import Breadcrumb from '@/components/Breadcrumb'
    import TabOne from '@/components/TabOne'
    import TabTwo from '@/components/TabTwo'
    import FooterMain from '@/components/FooterMain'
    import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
    import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

    export default {
        name: 'ElementTabs',
        components: {
            HeaderElement,
            Breadcrumb,
            TabOne,
            TabTwo,
            FooterMain,
            OffcanvasSearchBox,
            OffCanvasMobileMenu
        },

        metaInfo: {
            title: 'CREIS Japan - Element Tabs',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>

